import { render, staticRenderFns } from "./PdpDefault.vue?vue&type=template&id=3818e1cb&scoped=true&"
import script from "./PdpDefault.vue?vue&type=script&lang=js&"
export * from "./PdpDefault.vue?vue&type=script&lang=js&"
import style0 from "./PdpDefault.vue?vue&type=style&index=0&id=3818e1cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3818e1cb",
  null
  
)

export default component.exports